
namespace RioERP.Reports {
    export class OrderProductsColumns {
        static columnsKey = 'Reports.OrderProducts';
    }
}